import { render, staticRenderFns } from "./medicion-ausentismo-registro.vue?vue&type=template&id=70129978&scoped=true&"
import script from "./medicion-ausentismo-registro.vue?vue&type=script&lang=js&"
export * from "./medicion-ausentismo-registro.vue?vue&type=script&lang=js&"
import style0 from "./medicion-ausentismo-registro.vue?vue&type=style&index=0&id=70129978&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70129978",
  null
  
)

export default component.exports